// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html, body {
  height: 100%;
  overflow-x: hidden; /* Prevent horizontal scroll */
}

/* Enable vertical scrolling when viewport height < 800px */
@media (max-height: 799px) {
  html, body {
    overflow-y: auto;
  }
}

.app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.app-header {
  background-color: rgba(255, 255, 255, 0.95);
  padding: 2.5rem 2rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  text-align: center;
}

.app-header h1 {
  color: #333;
  font-size: 2.5rem;
  font-weight: 700;
  margin: 0 0 0.5rem 0;
}

.app-header .subtitle {
  color: #666;
  font-size: 1.1rem;
  margin: 0;
}

.app-main {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2rem;
}

@media (min-width: 1024px) {
  .app-main {
    padding: 0;
    justify-content: stretch;
    align-items: stretch;
    overflow: visible;
  }
}

@media (min-width: 1440px) {
  .app-main {
    padding: 0;
    justify-content: stretch;
    align-items: stretch;
    overflow: visible;
  }
}

.app-footer {
  background-color: rgba(0, 0, 0, 0.7);
  color: white;
  text-align: center;
  padding: 1rem;
  margin-top: auto;
}

.app-footer p {
  margin: 0;
  font-size: 0.9rem;
}

@media (max-width: 768px) {
  .app-header h1 {
    font-size: 1.8rem;
  }

  .app-header .subtitle {
    font-size: 1rem;
  }

  .app-main {
    padding: 1rem;
  }
}

`, "",{"version":3,"sources":["webpack://./src/styles/App.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,kBAAkB,EAAE,8BAA8B;AACpD;;AAEA,2DAA2D;AAC3D;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,2CAA2C;EAC3C,oBAAoB;EACpB,wCAAwC;EACxC,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,OAAO;EACP,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE;IACE,UAAU;IACV,wBAAwB;IACxB,oBAAoB;IACpB,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,UAAU;IACV,wBAAwB;IACxB,oBAAoB;IACpB,iBAAiB;EACnB;AACF;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":["html, body {\n  height: 100%;\n  overflow-x: hidden; /* Prevent horizontal scroll */\n}\n\n/* Enable vertical scrolling when viewport height < 800px */\n@media (max-height: 799px) {\n  html, body {\n    overflow-y: auto;\n  }\n}\n\n.app {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n}\n\n.app-header {\n  background-color: rgba(255, 255, 255, 0.95);\n  padding: 2.5rem 2rem;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  text-align: center;\n}\n\n.app-header h1 {\n  color: #333;\n  font-size: 2.5rem;\n  font-weight: 700;\n  margin: 0 0 0.5rem 0;\n}\n\n.app-header .subtitle {\n  color: #666;\n  font-size: 1.1rem;\n  margin: 0;\n}\n\n.app-main {\n  flex: 1;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 2rem;\n}\n\n@media (min-width: 1024px) {\n  .app-main {\n    padding: 0;\n    justify-content: stretch;\n    align-items: stretch;\n    overflow: visible;\n  }\n}\n\n@media (min-width: 1440px) {\n  .app-main {\n    padding: 0;\n    justify-content: stretch;\n    align-items: stretch;\n    overflow: visible;\n  }\n}\n\n.app-footer {\n  background-color: rgba(0, 0, 0, 0.7);\n  color: white;\n  text-align: center;\n  padding: 1rem;\n  margin-top: auto;\n}\n\n.app-footer p {\n  margin: 0;\n  font-size: 0.9rem;\n}\n\n@media (max-width: 768px) {\n  .app-header h1 {\n    font-size: 1.8rem;\n  }\n\n  .app-header .subtitle {\n    font-size: 1rem;\n  }\n\n  .app-main {\n    padding: 1rem;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
